module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapname2"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/teil2"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/teil3"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/teil3_1"
    }
  }, [_vm._v("Notes to the Reader")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/teil4"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/teil4#ch1"
    }
  }, [_vm._v("Light Tanks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teil5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teil5#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early-War Medium Tanks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teil6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teil6#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Late-War Medium Tanks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teil7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/teil7#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavy Tanks")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53eabc29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/inhalt.vue
// module id = 63
// module chunks = 0